import { render, staticRenderFns } from "./followSetting.vue?vue&type=template&id=2ee5d64e&scoped=true"
import script from "./followSetting.vue?vue&type=script&lang=js"
export * from "./followSetting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ee5d64e",
  null
  
)

export default component.exports